import React, { Component } from "react";

import "./Select.css";

class Select extends Component {
  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e.target.value, e.target.name);
    }
  }
  render() {
    return (
      <select className='select'
        name={this.props.name}
        onChange={this.onChange.bind(this)}
        value={this.props.value}
      >
        <option key='-1'>Please, select {this.props.name}</option>
        {this.props.options.map((o, i) => {
          return (<option key={i} value={o.value}>{o.name}</option>)
        })}
      </select>
    );
  }
}

export default Select;


// WEBPACK FOOTER //
// ./src/common/select/Select.js